import { isResponsiveProp } from "@faire/web--source/slate/Theme/ResponsiveProp";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
export var useResponsiveProp = function(prop) {
    return useResponsiveValue(isResponsiveProp(prop) ? prop : {
        mobileAndAbove: prop
    });
};
